import { useEffect, useState } from "react";
import withUser from "../../redux/HOC/withUser";
import ContractUpdateGrid from "./Grid";
import { Column } from "ag-grid-community";
import _ from "lodash";
import { validateDiv, validateTermDate } from "../../common/tradeValidations";
import { constants, messages } from "../../common/constants";
import moment from "moment";
import { updateContractMaintenance } from "../../utils/API";
import swal from "sweetalert";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

interface ContractUpdateProps {
  user: any;
  selectedRows: any;
  setUpdatedRowIds: any;
  setDoShowFullScreenLoader: any;
  doShowFullScreenLoader: any;
  closeUpdateContract: any;
  updateGridCells:any;
}

const ContractUpdate = ({
  user,
  selectedRows,
  setDoShowFullScreenLoader,
  setUpdatedRowIds,
  doShowFullScreenLoader,
  closeUpdateContract,
  updateGridCells
}: ContractUpdateProps) => {
  const [contractsBkp, setContractsBkp] = useState(JSON.stringify(selectedRows));

  const heightAG_1 = 30;
  const [contracts, setContracts] = useState<any>(selectedRows);
  const [isValidRequest, setIsValidRequest] = useState<boolean>(false);
  function isFloat(n: any) {
    return Number(n) === n && n % 1 !== 0;
  }

  const [markVal, setMarkVal] = useState<any>(null);
  const [div, setDiv] = useState<any>(null);
  const [termDate, setTermDate] = useState<any>(null);
  const [gridApi, setGridApi] = useState<any>(null);
  const [columnApi, setColumnApi] = useState<any>(null);


  const onUpdateCell = (data: any, value: any, column: Column) => {
    const contractList = JSON.parse(contractsBkp);
    const contract = contractList?.find((x:any) => data.contract_type == x.contract_type && data.contract_id == x.contract_id); 
      
    try {
      switch (column?.getColId()) {
        case "collMgn":
          if (
            _.isUndefined(data.collMgn) ||
            ((_.isString(data.collMgn) && _.isEmpty(data.collMgn)) || isNaN(data.collMgn))
          ) {
            data.collMgn = null;
            data.hasMarkError = true;
          } else if (
            isFloat(data.collMgn) ||
            data.collMgn <= 0 ||
            data.collMgn > 999
          ) {
            data.hasMarkError = true;
          } else {
            data.hasMarkError = false;
          }
          data.isMarkUpdated = contract && contract?.collMgn != data.collMgn;
          break;
        case "div":
          if (!data.div || data.div < 0 || data.div > 100 || isNaN(data.div)) {
            data.div = 100;
          }
          data.isDivUpdated = contract && contract?.div != data.div;
          data.hasDivError = false;
          break;
        case "term_date":
          if (data.term_date && !_.isEmpty(data.term_date)) {
            let tmpRowDate = moment(data.term_date);
            if (tmpRowDate.isValid()) {
              data.term_date = moment(data.term_date).format(
                constants.Date_Format
              );
              data.hasTermDateError = !validateTermDate(tmpRowDate);
            } else {
              data.hasTermDateError = true;
            }
          } else {
            data.term_date = "";
            data.hasTermDateError = false;
          }
          data.isTermDateUpdated = contract && contract?.term_date != data.term_date;;
          break;

        default:
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setContracts((previousRows: any) => {
        let rowIndex = previousRows?.findIndex(
          (c: any) =>
            c.contract_id === data.contract_id &&
            c.contract_type === data?.contract_type
        );
        data.isRowUpdated = (data?.isMarkUpdated || data?.isDivUpdated || data?.isTermDateUpdated)? true: false;
        if (rowIndex !== -1) previousRows[rowIndex] = data;
        let errorRowindex = previousRows?.findIndex(
          (x: any) => (x?.hasTermDateError || x?.hasMarkError || x?.hasDivError)
        );
        let updatedRowsIndex = previousRows?.findIndex(
          (x: any) => (x?.isRowUpdated)
        );
        setIsValidRequest(errorRowindex === -1 && updatedRowsIndex !== -1);
        return previousRows;
      });
    }
  };

  const updateContracts = async () => {
    try {
      setDoShowFullScreenLoader(true)
      let rows: any[] = [];
      let errors: any[] = [];
      rows = contracts?.map((item: any) => {
        let editedRows: any[] = [];
        if (item?.isMarkUpdated) {
          editedRows?.push({
            attribute: constants.MARK_PARAMETER_AMOUNT,
            value: item.collMgn,
          });
        }
        if (item?.isDivUpdated) {
          editedRows?.push({
            attribute: constants.DIVIDEND_FLOW_THRU_RATE,
            value: item.div,
          });
        }
        if (item?.isTermDateUpdated) {
          editedRows?.push({
            attribute: constants.TERM_DATE,
            value: item.term_date,
          });
        }

        return {
          bl: item?.contract_type,
          action: constants.CONTRACT_MAINTENANCE_REQUEST,
          contractId: item?.contract_id,
          changes: editedRows,
        };
        
      });

      let filteredRows =(rows && rows?.length >= 0) ? rows?.filter(x=> x?.changes && x.changes?.length>0):[];

      if (filteredRows && filteredRows?.length >= 0) {
        const accessToken = window.localStorage.getItem("refreshtoken");
        const response = await updateContractMaintenance(
          filteredRows,
          user?.tokenType,
          accessToken
        );
        if (response?.status === 200) {
          setUpdatedRowIds(_.map(contracts, "id"));
          let cmUpdateResponse = await response?.json();
          updateGridCells(filteredRows)
          cmUpdateResponse?.forEach((obj: any) => {
            if (obj.hasError === true) {
              errors.push(obj.status + " " + obj.error);
            }
          });
          if (errors.length > 0) {
            errors = _.uniq(errors);
            let error = messages.statuserror + "\n\n Error(s): \n";
            errors.map((e: any) => {
              error = error + e + "\n";
            });
            swal({
              title: constants.Error,
              text: error,
              dangerMode: true,
              closeOnClickOutside: false,
            });
          }
        }
      }
    } catch (err) {
    } finally {
      closeUpdateContract();
      setDoShowFullScreenLoader(false)
    }
  };

  const validateMark = (mark: any) => {
    if (
      _.isUndefined(mark) ||
      ((_.isString(mark) && _.isEmpty(mark)) || (isFloat(mark) ||
        mark <= 0 ||
        mark > 999))
    ) {
      return false;
    }
    return true;
  }

  const applyMark = () => {
    if (markVal) {
      let rows = [...contracts].map((row: any) => {
        return {
          ...row,
          collMgn: markVal,
          isMarkUpdated: true,
          hasMarkError: false
        }
      });

      setContracts((previousRows: any) => {
        previousRows = rows;
        let index = previousRows?.findIndex(
          (x: any) => x?.hasTermDateError || x?.hasMarkError || x?.hasDivError
        );
        setIsValidRequest(index === -1);
        return previousRows;
      });
    }

  }

  const applyDiv = () => {
    if (div) {
      let rows = [...contracts].map((row: any) => {
        return {
          ...row,
          div: div,
          isDivUpdated: true,
          hasDivError: false
        }
      });

      setContracts((previousRows: any) => {
        previousRows = rows;
        let index = previousRows?.findIndex(
          (x: any) => x?.hasTermDateError || x?.hasMarkError || x?.hasDivError
        );
        setIsValidRequest(index === -1);
        return previousRows;
      });
    }

  }

  const applyTermDate = () => {
    if (!termDate || (termDate && validateTermDate(termDate))) {
      let rows = [...contracts].map((row: any) => {
        return {
          ...row,
          term_date: moment(termDate)?.format("MM/DD/yyyy"),
          isTermDateUpdated: true,
          hasTermDateError: false
        }
      });

      setContracts((previousRows: any) => {
        previousRows = rows;
        let index = previousRows?.findIndex(
          (x: any) => x?.hasTermDateError || x?.hasMarkError || x?.hasDivError
        );
        setIsValidRequest(index === -1);
        return previousRows;
      });
    }

  }

  const handleLetterAlloweDiv = (e: any) => {
    let alloweOnlyLetter = /[0-9]/gm.test(e.key);
    if (!alloweOnlyLetter) {
      e.preventDefault();
    }
  };

  const onKeyDownFocus = (e: any) => {
    if (e.key === "Tab" && (termDate && validateTermDate(termDate))) {
      window.setTimeout(function () {
        document.getElementById("termDateBtn")?.focus();
      }, 0);
    }
    else if (e.key === "Tab" && isValidRequest) {
      window.setTimeout(function () {
        document.getElementById("submit")?.focus();
      }, 0);
    } else {
      getFocusToEditalbeColumn(e);
    }
  }

  const getFocusToEditalbeColumn = (e:any)=>{
    if (e.key === "Tab" && isValidRequest) {
      window.setTimeout(function () {
        document.getElementById("submit")?.focus();
      }, 0);
    } else {
      if(e?.key !== 'Tab') return;
 
      // prevents tabbing into the url section
      e?.preventDefault();
      // scrolls to the first row
      gridApi?.ensureIndexVisible(0);
        
      // scrolls to the first column
      const columnList = columnApi?.getAllDisplayedColumns();
      let column = columnList?.find((x:any)=>x?.colId === 'collMgn');
      if(column){
        gridApi?.ensureColumnVisible(column);
        // sets focus into the first grid cell
        gridApi?.setFocusedCell(0,column);
      }
    }

  }

  const focusOnInit = ()=> {
    window.setTimeout(function () {
      document?.getElementById("mark")?.focus();
    }, 0);
  }

  useEffect(()=>{
    focusOnInit();
  },[])

  return (
    <>
      <div className="d-flex flex-row mb-4 justify-content-between">
        <div className="d-flex flex-row justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <label className="" style={{ fontWeight: "600" }}>
              Mark
            </label>
            <div className="d-flex flex-column" style={{height:'2rem'}}>
              <input
                className="ms-2 input-style inputBorderNone"
                type="number"
                name="mark"
                id="mark"
                onInput={(event: any) => {
                  setMarkVal(event?.target?.value);
                }}
                placeholder="Enter Mark"
                style={{ height: "2.2rem" }}
              />
              {markVal && !validateMark(markVal) && (
                <div>
                  <span className="ms-2 error-style">
                    Please enter valid mark
                  </span>
                </div>
              )}
            </div>
            <div className="ms-2 h-100 d-flex align-items-center">
              <button
                type="submit"
                className={"btn btn-outline-primary outline-btn"}
                disabled={!markVal || (markVal && !validateMark(markVal))}
                onClick={() => {
                  applyMark();
                }}
              >
                Apply
              </button>
            </div>
          </div>

          <div className="d-flex flex-row align-items-center">
            <label className="ms-2" style={{ fontWeight: "600" }}>
              Div
            </label>
            <div className="d-flex flex-column" style={{height:'2rem'}}>
              <input
                className="ms-2 input-style inputBorderNone"

                name="div"
                id="div"
                onInput={(event: any) => {
                  let dividend = event?.target?.value;
                  if (dividend < 0 || dividend > 100 || isNaN(dividend)) {
                    setDiv(100);
                  } else {
                    setDiv(event?.target?.value);
                  }
                }}
                maxLength={3}
                placeholder="Enter Div"
                style={{ height: "2.2rem" }}
                onKeyPress={handleLetterAlloweDiv}
                value={div}
              />
            </div>
            <div className="ms-2 h-100 d-flex align-items-center">
              <button
                type="submit"
                className={"btn btn-outline-primary outline-btn"}
                disabled={!div || (div && !validateDiv(div))}
                onClick={() => {
                  applyDiv();
                }}
              >
                Apply
              </button>
            </div>
          </div>

          <div className="d-flex flex-row align-items-center">
            <label className="ms-2 me-2" style={{ fontWeight: "600" }}>
              Term Date
            </label>
            <div onKeyDown={onKeyDownFocus} 
              className="d-flex flex-column" style={{height:'2rem'}}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  disablePast
                  openTo="day"
                  className="onFocusOutTermDateID"
                  views={["year", "month", "day"]}
                  minDate={moment().toDate()}
                  value={termDate}
                  inputFormat="MM/dd/yyyy"
                  InputProps={{
                    notched: false,
                    style: { fontSize: 13, color: "#212529" },
                  }}
                  
                  onChange={(newValue: any) => {
                      setTermDate(newValue);
                  }}
                  renderInput={(params: any) => (
                    <TextField
                      variant="outlined"
                      sx={{
                        "& .MuiInputBase-input": {
                          height: "0.4rem",
                          width: "4.4rem",
                          border: "none",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                      style={{
                        border: "1px solid #eaecef",
                        fontSize: "0.8rem",
                        color: "#212529",
                      }}
                      className="inputStyleNew"
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
              {termDate && !validateTermDate(termDate) && (
                <div className="error-style">
                  {messages.selectFutureDateMessage}
                </div>
              )}
            </div>
            <div className="ms-2 h-100 d-flex align-items-center">
              <button
                type="submit"
                id="termDateBtn"
                className={"btn btn-outline-primary outline-btn"}
                onKeyDown={getFocusToEditalbeColumn}
                disabled={!termDate || (termDate && !validateTermDate(termDate))}
                onClick={() => {
                  applyTermDate();
                }}

              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
      <ContractUpdateGrid
        rowData={contracts}
        height={heightAG_1}
        onCellChange={(data: any, value: any, column: Column) => {
          onUpdateCell(data, value, column);
        }}
        getGridApi={
          (gridApi:any)=>{
            setGridApi(gridApi);
          }
        }
        getColumnApi={
          (columnApi:any)=>{
            setColumnApi(columnApi);
          }
        }
      />

      <div className="d-flex justify-content-end">
        <div className="ms-2 h-100 d-flex align-items-center metrics-div">
          <button
            type="submit"
            id="submit"
            className={"btn btn-primary uploadSheet-submit-Btn mt-2"}
            onClick={() => {
              updateContracts();
            }}
            disabled={!isValidRequest}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default withUser(ContractUpdate);
